/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CompanyItem } from '../../models/company-item';

export interface CompanyControllerFindOne$Params {
  id: number;
}

export function companyControllerFindOne(http: HttpClient, rootUrl: string, params: CompanyControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CompanyItem;
}>> {
  const rb = new RequestBuilder(rootUrl, companyControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CompanyItem;
      }>;
    })
  );
}

companyControllerFindOne.PATH = '/company/{id}';
